import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function About() {
  return (
    <div className="pt-28 pb-28">
      <Seo title="About Us" description="Equine Evolve honours legacies — each piece inspired by real horses, real stories and real craftsmanship. Proudly rooted in Ireland." />
      <div className="relative h-[50vh] overflow-hidden ee-grain">
        <img src="/images/brand-hero.jpg" alt="Equine Evolve" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0C0A09] via-black/50 to-black/40" />
        <div className="relative h-full flex flex-col items-center justify-center text-center px-6">
          <Reveal>
            <p className="ee-overline mb-4">Our Story</p>
            <h1 className="font-display text-5xl md:text-7xl tracking-tight">Equestrian Elegance, Redefined</h1>
          </Reveal>
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-24 max-w-[1100px] mx-auto py-24">
        <Reveal>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight leading-tight">
            Step into a world where elegance meets passion, and every piece tells a story of timeless
            equestrian heritage.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="grid md:grid-cols-2 gap-12 mt-14 text-[#A8A29E] leading-relaxed">
            <p>
              From handcrafted gold bangles inspired by Ireland's most iconic horses to signature
              three-wick candles evoking the scent of saddle leather and oak-lined stables — our
              curated collection celebrates the spirit of the sport-horse lifestyle.
            </p>
            <p>
              We don't just create products — we honour legacies. Each item is inspired by real horses,
              real stories, and real craftsmanship. Proudly rooted in Ireland and loved around the
              world, every piece blends stable-born authenticity with refined luxury.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="grid sm:grid-cols-3 gap-8 mt-20">
            {[["100%", "Handcrafted"], ["Ireland", "Proudly based"], ["Worldwide", "Loved by riders"]].map(([big, small]) => (
              <div key={small} className="border ee-hairline bg-[#1C1917] p-8 text-center">
                <p className="font-display text-4xl ee-gold-text">{big}</p>
                <p className="text-xs text-[#A8A29E] mt-2 uppercase tracking-[0.15em]">{small}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <div className="text-center mt-20">
          <Link to="/shop" className="bg-[#D4AF37] text-[#0C0A09] px-10 py-4 uppercase tracking-[0.15em] text-sm hover:bg-[#B5952F] transition-colors">
            Explore the Collection
          </Link>
        </div>
      </div>
    </div>
  );
}
